import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.DELETE_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/deleteTrigger.js